import { useOpenWithFaireApplicationStatus } from "@faire/retailer-visitor-shared/stores/domain/OpenWithFaire/useOpenWithFaireApplicationStatus";
import { IRetailerLaunchWithFaire } from "@faire/web-api--source/indigofair/data/IRetailerLaunchWithFaire";

export const useIsSoftCreditCheckApplication = () => {
  const { applicationType } = useOpenWithFaireApplicationStatus();

  return {
    isSoftCreditCheckApplication:
      applicationType ===
      IRetailerLaunchWithFaire.ApplicationType.SOFT_CREDIT_CHECK,
  };
};
